<button layout='column' class="center" mat-mini-fab color="primary" matBadge="{{getQtdItensNoCarrinho()}}" matBadgePosition="before" matBadgeColor="accent" [matMenuTriggerFor]="menu"> 
	<mat-icon>shopping_cart</mat-icon>
</button>	  

<mat-menu #menu="matMenu" class="menu">
	<div (click)="$event.stopPropagation();">
		<app-carrinho></app-carrinho>
	</div>
</mat-menu> 